let deferredPage = '';

export default {
  install: (
    app: any,
    { disabled, gaId }: { disabled: boolean; gaId: string }
  ) => {
    const _gtag = {
      trackEvent(event: string, params: any) {},
      trackPage(path: string) {
        deferredPage = path;
      }
    };

    if (gaId && !disabled) {
      gaId = `G-${gaId}`;

      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          // biome-ignore lint/style/noArguments:
          dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', gaId, {
          cookie_flags: 'samesite=none;secure',
          send_page_view: false
        });

        _gtag.trackPage = (path: string) => {
          gtag('event', 'page_view', {
            page_location: path
          });
          console.log(`Track page: ${path}`);
        };

        _gtag.trackEvent = (event: string, params = {}) => {
          const path = `widget_${event}`;
          gtag('event', path, params);
          console.log(`Track event: ${path}`);
        };

        if (deferredPage) {
          _gtag.trackPage(deferredPage);
          deferredPage = '';
        }
      };
    }

    app.provide('gtag', _gtag);
  }
};
